import type { FC } from "react";

import styled from "@emotion/styled";
import translate from "src/lib/translate";
import Meals from "src/ui/components/Meals/Meals";
import InDialog from "src/ui/components/InDialog/InDialog";
import useGoToOrBack from "src/ui/hooks/useGoToOrBack";

import { AppQueryPopupsController } from "../AppQueryPopupsBloc";

const MealPlanningInDialog = styled(InDialog)`
  & > * {
    padding-bottom: 0;
  }

  .close {
    width: 2rem;
    height: 2rem;
    padding: 0;
    border-radius: 200px;
    background: rgba(33, 33, 33, 0.12);

    svg {
      width: 1.5rem;
      height: 1.5rem;
      color: #212121;
    }

    svg path {
      fill-opacity: 1;
    }
  }

  @media (min-width: 768px) and (min-height: 768px) {
    width: calc(100vw - 4rem);
    height: calc(100vh - 5rem);
    max-width: calc(100vw - 4rem);
    max-height: calc(100vh - 5rem);
    border-radius: 0.5rem;

    .header {
      padding: 0 1.5rem 0 2.5rem;
    }

    .header-spacer {
      display: none;
    }

    .title {
      flex: 0 1 auto;
      text-align: left;
    }
  }
`;

const MealPlanningDialog: FC<{ returnUrl: string }> = ({ returnUrl }) => {
  const navigate = useGoToOrBack();

  const onClose = () => {
    AppQueryPopupsController.closePopup();
    navigate(returnUrl, { multiBack: true, replace: true });
  };

  return (
    <MealPlanningInDialog
      popup
      isFullScreen
      noPadding
      title={translate("mealInsights.mealPlanner.title")}
      onClose={onClose}
      returnUrl={returnUrl}
    >
      <Meals />
    </MealPlanningInDialog>
  );
};

export default MealPlanningDialog;
